import { Box, Button, Container, Grid, styled } from "@mui/material";

const modalStyle = {
    position: 'absolute',
    top: '18%',
    left: '27.5%',
    width: '45%',
    bgcolor: 'background.paper',
    textAlign: 'center',
    borderRadius: '15px',
};

const ModalLabel = styled(Box)(() => ({
    backgroundColor: '#41DBCE',
    fontSize: '1.3rem',
    color: '#FFFFFF',
    height: '2.2rem',
    paddingTop: '0.5rem',
    borderRadius: '15px 15px 0 0',
    textAlign: 'left',
    paddingLeft: '1rem',
    boxSizing: 'content-box'
}));

const CheckBoxContainer = styled(Container)(() => ({
    overflowY: 'scroll',
    width: '70%',
    maxHeight: '15rem',
    textAlign: 'left',
    border: '2px solid #dcdcdc',
}));

const CancelButton = styled(Button)(() => ({
    backgroundColor: '#BFBFBF',
    color: '#000000',
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: 'bold',
    height: '2.5rem',
    width: '8rem',
    borderRadius: '100rem'
}));

const OkButton = styled(Button)(() => ({
    backgroundColor: '#01CFBE',
    color: '#FFFFFF',
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: 'bold',
    height: '2.5rem',
    width: '5rem',
    borderRadius: '100rem',
    marginLeft: '1rem'
}));

const TextFieldLabel = styled(Grid)(() => ({
    backgroundColor: '#595959',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const TextFieldForm = styled(Grid)(() => ({
    backgroundColor: '#FFFFFF',
}));

export { modalStyle, ModalLabel, CheckBoxContainer, CancelButton, OkButton, TextFieldLabel, TextFieldForm }
